/** Display the product line while leaving full artifact versions intact in API responses. */
export function productLine(version: string): string {
  const match = /^(\d+)\.(\d+)\.\d+(?:[-+][0-9A-Za-z.-]+)?$/.exec(version);
  return match ? `${match[1]}.${match[2]}` : version;
}
